
export const GITHUB_ISSUE_URL = 'https://github.com/xenova/transformers.js/issues/new/choose';